import conversationApi from 'apis/CompanyAPI/conversations/conversationApi';
import { downloadBlob } from 'domain/shared/Files/actions';
import { track } from 'util/analytics';

export const getMeAsCompany = (companyId: number, cwUserId: string) => conversationApi.company.me(companyId, cwUserId);

export async function downloadAttachment(fileId: string) {
  const response = await conversationApi.downloadAttachment(fileId);
  await downloadBlob(response);
}

interface TrackConversationOpened {
  withCompanyId: number;
  key: string;
  path: string;
  communitySlug?: string;
}

export async function trackConversationOpened(context: TrackConversationOpened) {
  try {
    await conversationApi.trackConversationOpened({
      key: context.key,
      withCompanyId: context.withCompanyId,
      path: context.path,
      openedFromCommunitySlug: context.communitySlug,
    });
    track(`conversation-opened--${context.key}`);
  } catch {}
}
